import React from "react"
import "./SwitchingContentContainer.styles.scss"

const SwitchingContentContainer: React.FC = (props) => {
	const { children } = props

	return <div className="switching-content-container">{children}</div>
}

export default SwitchingContentContainer
